import React from 'react';
import MaterialTable from 'material-table';
import {pasillosResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import tableicons from "../tableicons"
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import useToken from "../useToken";

class PasillosParaAuditar extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos: [],
            openSnack:false,
            severity: null,
            message:null,
            selectedRow: null,
            seleccionados:[],
            user: useToken.getUser(),
            agregar_pasillos: false,
        }
    };

    obtenerDatos = () => {
        pasillosResources.obtenerPasillosSinAuditar().then(async (response) => {
                if (response) {
                    return await response.json();
                }
            }).then((result) => {
                if (result.status_code === 200) {
                    this.setState({ datos: result.pasillos, cargando: false });
                } else if (result.status_code === 401) {
                    this.setState({ openSnack: true, severity: result.severity, message: result.message, cargando: false });
                } else {
                    this.setState({ cargando: false });
                    throw new Error('Something went wrong ...');
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    cargando: false,
                    openSnack: true,
                    severity: 'error',
                    message: 'Ha ocurrido un error al obtener los datos',
                });
            });
    };

    agregarPasilloAuditoria = () =>{
        this.setState({ cargando: true, openSnack: false, severity: null, message: null });
        const pasillosParaAuditar={
            pasillos: this.state.seleccionados,
            valor: "t",
            usuario:this.state.user.id_usuario
        }
        pasillosResources.agregarPasillosAuditoria(pasillosParaAuditar).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({
                    openSnack: true,
                    severity: result.severity,
                    message: result.message,
                    cargando: false,
                })
                if(result.severity === "success"){
                    this.obtenerDatos()
                }
            }
            else{
                throw new Error('Something went wrong ...');
            }

        }).catch(error=> {
            console.log(error)
            this.setState({
                openSnack: true,
                cargando: false,
                severity: 'error',
                message: "Ha ocurrido un error inesperado",
            })
        });

    }

    componentWillMount() {
        this.obtenerDatos();
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Agregar pasillos a auditoría
                </Typography>

                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                    <Grid item>
                        <Button  size="large" variant="contained" disabled={this.state.seleccionados.length === 0}
                                 color="primary" onClick={() => this.setState(()=>this.agregarPasilloAuditoria())}>
                            Agregar a auditoría</Button>

                    </Grid>
                </Grid>

                <MaterialTable
                    isLoading={this.state.cargando}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} fila(s) seleccionado(s)"
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 50,
                        selection:true,
                        defaultExpanded: true,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.datos}
                    columns={[
                        { title: 'Area', field: 'area', render: rowData => rowData.padre == null ?  rowData.area : '',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Número', field: 'numero',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                        { title: 'Descripción', field: 'descripcion',
                            cellStyle: {
                                width: 500,
                                maxWidth: 500,
                            },
                            headerStyle: {
                                width: 500,
                                maxWidth: 500
                            }},
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    onSelectionChange={(rows) => this.setState({seleccionados:rows})}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}
export default PasillosParaAuditar;